export default "__VITE_PUBLIC_ASSET__f4481df8__"